import errorImage from '../assets/img-error.svg';

export {
    errorImage,
};

export default {
    methods: {
        handleRefImgError(imageRef = 'img') {
            const ref = typeof imageRef === 'string' ? imageRef : 'img';
            if (this.$refs[ref]) {
                let ele = this.$refs[ref];
                ele = Array.isArray(ele) ? ele[0] : ele;
                // ChangWei
                // eslint-disable-next-line no-console
                console.warn(`Image Ref '${ref}' Error: ${ele.src}`);
                ele.src = errorImage;
            }
        },
    },
};
